import React, { ReactElement } from 'react';

import { Box, CircularProgress } from '@myn/mui';

import { VersionView as VersionViewType } from '../../types/versions.js';
import VersionsTableView from './VersionsTableView/VersionsTableView.jsx';

type Props = {
  currentView: VersionViewType;
  isLoading: boolean;
  children: ReactElement;
  versions?: {
    id: number;
  }[];
};

const VersionViewComponent: React.FC<Props> = ({
  currentView,
  isLoading,
  children,
  versions,
}) => {
  const mixView = isLoading ? (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
      }}
    >
      <CircularProgress size={40} />
    </Box>
  ) : (
    children
  );

  return currentView === VersionViewType.Table ? (
    <VersionsTableView sortedVersions={versions} />
  ) : (
    mixView
  );
};

export default VersionViewComponent;
